import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { combineFirstAndLastName, getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const PRODUCT_ID = '1012222303009777000'
const TYPE = 'Savings'
const beneficiaryType = 'DMR'

const parsedDataBody = (body: any) => {
  return {
    remitterId: body?.remittanceUserId || RootStore?.customerDetails?.newRemittanceUserId, //remittanceUserId
    productId: PRODUCT_ID, //hard code
    accountNumber: body?.beneficiaryAccountNumber, //Acc num same
    accountHolderName: body?.accountHolderName,
    nickName: combineFirstAndLastName(body?.beneficiaryFirstName ?? '', body?.beneficiaryLastName ?? ''),
    accountType: TYPE?.toUpperCase(), //Hard code
    ifscCode: body?.ifscCode,
    mobileNumber: {
      countryCode: '91',
      number: body?.mobile,
    },
    beneficiaryType: beneficiaryType, //hard code
    createdBy: RootStore?.agent?.session?.CHANNEL_ID, //Channel ID
    createdFromChannel: RootStore?.agent?.session?.CHANNEL_ID, //Channel ID
    field5: 'B93,B94',
  }
}

const responseParser = (data: any) => {
  if (isStatusOK(data)) {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

export const addNewBeneficiaryApi = (tokens: any, body: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  const request: Request<{}> = {
    apiPath: APIEndPoints.addNewBeneficiary,
    method: 'POST',
    config: config,
    body: parsedDataBody(body),
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
